import { API_URL, PRESERVED_PARAM_KEYS } from '@/config';
import Axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import i18n from 'i18next';

export type AxiosResponseInterceptor<T> = T;

export const axios = applyCaseMiddleware(
  Axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  }),
  {
    preservedKeys: PRESERVED_PARAM_KEYS, // これらのパラメータは変換から除外
  }
);

axios.interceptors.request.use((request) => {
  request.headers['Accept-Language'] = i18n.language;
  return request;
});

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // const message = error.response?.data?.message || error.message;
    // useNotificationStore.getState().addNotification({
    //   type: 'error',
    //   title: 'Error',
    //   message,
    // });

    return Promise.reject(error);
  }
);
